import { merge } from 'lodash';
import authResolver from './auth.resolver';
import loaderResolver from './loader.resolver';
import userResolver from './user.resolver';
import offerResolver from './offer.resolver';


export default merge(authResolver, userResolver, loaderResolver, offerResolver);
